import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isShowCta',
  standalone: true,
})
export class IsShowCtaPipe implements PipeTransform {
  transform(highlightProjects: number, storeProjects: number | undefined = undefined): boolean {
    if (!storeProjects) return true;
    return storeProjects > highlightProjects;
  }
}
